import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import QRCode from "qrcode";
import { toast, ToastContainer } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import chaafo from "../../images/chAafo Logo.svg";
import HandiLogo from "../../images/Handi_Logo.png";
import JFCLogo from "../../images/JFCLogo.png";

import SRLogo from "../../images/Dining_QR_Images/sr.png";
import ChawlaLogo from "../../images/Dining_QR_Images/chawlalogo.jpg";

import JSZip from "jszip";
import { saveAs } from "file-saver";
import MyContext from "../../MyContext"; //using ContextAPI to store data dynamically
const QR_Code = ({ userID }) => {
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);

  const [tables, setTables] = useState([]);

  const [isGeneratingPDF_5_10, setIsGeneratingPDF_5_10] = useState(false);
  const [isGeneratingPDF_10_15, setIsGeneratingPDF_10_15] = useState(false);
  const [isGeneratingZIP_5_10, setIsGeneratingZIP_5_10] = useState(false);
  const [isGeneratingZIP_10_15, setIsGeneratingZIP_10_15] = useState(false);
  const [isGeneratingZIP_Only, setIsGeneratingZIP_Only] = useState(false);
  const fetchTableApi = async () => {
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/getRestaurantTable`,
        requestBody,
        config
      );
      // Access the response correctly
      if (response.data.responseCode === "00") {
        setTables(response.data.response); // Correctly access the response data
        // toast.success(response.data.responseMessage);
      }
    } catch (error) {
      console.error("Error fetching tables:", error); // Add error logging
      // toast.error("Failed to fetch tables.");
    }
  };

  useEffect(() => {
    fetchTableApi();
  }, []);

  const generateQRCodeURLOnly = async (
    tableId,
    retaurentName,
    qrUrl,
    whatsappNumber,
    message
  ) => {
    const message1 =
      "Hello, I’m seated at Table No. 4 and would like to place my order. Thank you!";
    const phoneNumber = "919266525351";
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;

    try {
      const qrCodeDataUrl = await QRCode.toDataURL(whatsappLink, {
        errorCorrectionLevel: "H",
        margin: 1,
        scale: 100, // Higher scale for ultra HD (scale of 100 gives ~3000px QR)
      });

      const qrImage = new Image();
      qrImage.src = qrCodeDataUrl;

      return new Promise((resolve) => {
        qrImage.onload = () => {
          const sizeInPixels = 3000; // Ultra Full HD (about 10 inches at 300dpi)
          const canvas = document.createElement("canvas");
          canvas.width = sizeInPixels;
          canvas.height = sizeInPixels;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(qrImage, 0, 0, sizeInPixels, sizeInPixels);

          const finalQRCode = canvas.toDataURL("image/png", 1.0); // High quality
          resolve(finalQRCode);
        };
      });
    } catch (err) {
      console.error("Failed to generate QR Code", err);
      return null;
    }
  };

// ===============================
// ✅ 5x10 (Landscape) — NO OVERLAP GUARANTEED (Top-aligned name box)
// ===============================
const generateQRCodeURL_5_10 = async (
  tableId,
  restaurantName,
  qrUrl,
  whatsappNumber,
  message
) => {
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    message
  )}`;

  // ✅ Wrap text inside a FIXED box (auto-shrink; top-aligned; never overlaps below)
  const drawWrappedTextInBoxTop = (
    ctx,
    text,
    boxX,
    boxY,
    boxWidth,
    boxHeight,
    baseFontSize,
    maxLines = 2,      // ✅ keep 2 lines for 5x10 to avoid collision
    minFontSize = 14,
    fontFamily = "'Poppins','Segoe UI',sans-serif"
  ) => {
    let fontSize = baseFontSize;
    let lines = [];

    const buildLines = () => {
      ctx.font = `bold ${fontSize}px ${fontFamily}`;
      const words = (text || "").toString().trim().split(/\s+/);
      lines = [];
      let line = "";

      for (let i = 0; i < words.length; i++) {
        const test = line ? `${line} ${words[i]}` : words[i];
        if (ctx.measureText(test).width <= boxWidth) {
          line = test;
        } else {
          if (line) lines.push(line);
          line = words[i];
        }
      }
      if (line) lines.push(line);

      // cap lines
      if (lines.length > maxLines) lines = lines.slice(0, maxLines);
    };

    const fits = () => {
      const lineHeight = fontSize + 8;
      return lines.length * lineHeight <= boxHeight;
    };

    // shrink until fits height
    while (fontSize > minFontSize) {
      buildLines();
      if (fits()) break;
      fontSize -= 2;
    }

    buildLines();

    // ellipsis if still too long
    const lineHeight = fontSize + 8;
    if (!fits() && lines.length) {
      const lastIndex = lines.length - 1;
      let last = lines[lastIndex] || "";
      while (ctx.measureText(last + "...").width > boxWidth && last.length > 0) {
        last = last.slice(0, -1);
      }
      lines[lastIndex] = (last.trim() || "") + "...";
    }

    // ✅ TOP aligned inside box (no vertical centering)
    ctx.font = `bold ${fontSize}px ${fontFamily}`;
    ctx.textAlign = "center";

    let y = boxY + lineHeight; // start near top
    for (let i = 0; i < lines.length; i++) {
      const drawY = y + i * lineHeight;

      // ✅ hard stop: never draw beyond box bottom
      if (drawY > boxY + boxHeight) break;

      ctx.fillText(lines[i], boxX + boxWidth / 2, drawY);
    }
  };

  try {
    const canvasWidth = 1181;
    const canvasHeight = 591;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    // === Background Gradient ===
    const bgGradient = ctx.createLinearGradient(0, 0, 0, canvasHeight);
    bgGradient.addColorStop(0, "#FFD54F");
    bgGradient.addColorStop(1, "#FF9800");
    ctx.fillStyle = bgGradient;
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);

    // === Inner Card ===
    const padding = 30;
    const cardX = padding;
    const cardY = padding;
    const cardWidth = canvasWidth - padding * 2;
    const cardHeight = canvasHeight - padding * 2;
    const radius = 30;

    const cardGradient = ctx.createLinearGradient(0, cardY, 0, cardY + cardHeight);
    cardGradient.addColorStop(0, "#fff8e1");
    cardGradient.addColorStop(1, "#ffe0b2");

    ctx.fillStyle = cardGradient;
    ctx.beginPath();
    ctx.moveTo(cardX + radius, cardY);
    ctx.lineTo(cardX + cardWidth - radius, cardY);
    ctx.quadraticCurveTo(cardX + cardWidth, cardY, cardX + cardWidth, cardY + radius);
    ctx.lineTo(cardX + cardWidth, cardY + cardHeight - radius);
    ctx.quadraticCurveTo(
      cardX + cardWidth,
      cardY + cardHeight,
      cardX + cardWidth - radius,
      cardY + cardHeight
    );
    ctx.lineTo(cardX + radius, cardY + cardHeight);
    ctx.quadraticCurveTo(cardX, cardY + cardHeight, cardX, cardY + cardHeight - radius);
    ctx.lineTo(cardX, cardY + radius);
    ctx.quadraticCurveTo(cardX, cardY, cardX + radius, cardY);
    ctx.closePath();
    ctx.fill();

    // === Load Assets ===
    const qrCodeDataUrl = await QRCode.toDataURL(whatsappLink, {
      errorCorrectionLevel: "H",
      margin: 1,
      scale: 8,
    });

    const qrImage = new Image();
    const chaafoImage = new Image();
    const handiImage = new Image();

    qrImage.src = qrCodeDataUrl;
    chaafoImage.src = chaafo;
    handiImage.src = ChawlaLogo;

    return new Promise((resolve) => {
      qrImage.onload = () => {
        chaafoImage.onload = () => {
          handiImage.onload = () => {
            const midX = canvasWidth / 2;
            const leftCenterX = midX / 2;

            // Logo metrics (even if logo not drawn)
            const logoMaxWidth = 100;
            const logoAspectRatio = handiImage.width / handiImage.height;
            const logoWidth = logoMaxWidth;
            const logoHeight = logoWidth / logoAspectRatio;
            const logoY = cardY + 30;

            // === FIXED TABLE POSITION (YOUR ORIGINAL) ===
            const tableY = logoY + logoHeight + 140;

            // ✅ STRICT NAME BOX (ENDS WELL ABOVE TABLE)
            ctx.fillStyle = "#d84315";

            const nameBoxX = cardX + 40;
            const nameBoxY = logoY + logoHeight + 10;
            const nameBoxWidth = midX - 80;

            // 🔥 IMPORTANT: hard-limit height so it NEVER touches TABLE
            const nameBoxHeight = Math.max(40, tableY - nameBoxY - 70); 
            // "70" = reserved gap above TABLE (increase if you want more space)

            drawWrappedTextInBoxTop(
              ctx,
              restaurantName,
              nameBoxX,
              nameBoxY,
              nameBoxWidth,
              nameBoxHeight,
              44, // base font
              2,  // ✅ 2 lines max in 5x10 (prevents collision)
              16
            );

            // === Table Number (UNCHANGED) ===
            ctx.font = "bold 72px 'Segoe UI', sans-serif";
            ctx.fillStyle = "#ef6c00";
            ctx.textAlign = "center";
            ctx.fillText(`TABLE ${tableId}`, leftCenterX, tableY);

            // === Scan Text (UNCHANGED) ===
            ctx.font = "500 48px 'Segoe UI', sans-serif";
            ctx.fillStyle = "#4e342e";
            ctx.fillText("Scan To Order", leftCenterX, logoY + logoHeight + 230);
            ctx.fillText("On WhatsApp", leftCenterX, logoY + logoHeight + 290);

            // === Footer (UNCHANGED) ===
            const chaafoWidth = 120;
            const chaafoHeight = 40;
            const footerY = cardY + cardHeight - 50;

            ctx.font = "20px 'Poppins', sans-serif";
            ctx.fillStyle = "#333";
            ctx.fillText("Powered by", leftCenterX, footerY - 10);
            ctx.drawImage(
              chaafoImage,
              leftCenterX - chaafoWidth / 2,
              footerY,
              chaafoWidth,
              chaafoHeight
            );

            // === QR Right (UNCHANGED) ===
            const qrSize = 400;
            const qrX = midX + (midX - qrSize) / 2;
            const qrY = cardY + (cardHeight - qrSize) / 2;
            ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize);

            resolve(canvas.toDataURL("image/png", 1.0));
          };
        };
      };
    });
  } catch (err) {
    console.error("Failed to generate QR Sticker", err);
    return null;
  }
};


// ===============================
// ✅ 10x15 (Portrait) — Name fits fully (up to 3 lines) WITHOUT affecting QR / footer
// ===============================
const generateQRCodeURL_10_15 = async (
  tableId,
  retaurentName,
  qrUrl,
  whatsappNumber,
  message
) => {
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    message
  )}`;

  // ✅ Wrap text inside a fixed box (auto-shrink; ellipsis ONLY if impossible)
  const drawWrappedTextInBox = (
    ctx,
    text,
    boxX,
    boxY,
    boxWidth,
    boxHeight,
    baseFontSize,
    maxLines = 3,
    minFontSize = 12,
    fontFamily = "'Poppins','Segoe UI',sans-serif"
  ) => {
    let fontSize = baseFontSize;
    let lines = [];

    const buildLines = () => {
      ctx.font = `bold ${fontSize}px ${fontFamily}`;
      const words = (text || "").toString().trim().split(/\s+/);
      lines = [];
      let line = "";

      for (let i = 0; i < words.length; i++) {
        const test = line ? `${line} ${words[i]}` : words[i];
        if (ctx.measureText(test).width <= boxWidth) {
          line = test;
        } else {
          if (line) lines.push(line);
          line = words[i];
        }
      }
      if (line) lines.push(line);

      // if more than maxLines, keep only maxLines for now (we might shrink to fit)
      if (lines.length > maxLines) lines = lines.slice(0, maxLines);
    };

    const fitsInBox = () => {
      const lineHeight = fontSize + 8;
      return lines.length * lineHeight <= boxHeight;
    };

    // Shrink until it fits height and (roughly) doesn't need extra lines
    while (fontSize > minFontSize) {
      buildLines();

      // If original would produce more lines than allowed, shrink and retry
      // (We approximate by checking if even with slicing it still overflows height)
      if (fitsInBox()) break;

      fontSize -= 2;
    }

    // Final build
    buildLines();

    // If still not fitting (very extreme cases), add ellipsis on last line
    if (!fitsInBox()) {
      const lastIndex = Math.min(lines.length, maxLines) - 1;
      let last = lines[lastIndex] || "";
      while (ctx.measureText(last + "...").width > boxWidth && last.length > 0) {
        last = last.slice(0, -1);
      }
      lines[lastIndex] = (last.trim() || "") + "...";
    }

    ctx.font = `bold ${fontSize}px ${fontFamily}`;
    ctx.textAlign = "center";

    const lineHeight = fontSize + 8;
    const textHeight = lines.length * lineHeight;
    const startY = boxY + (boxHeight - textHeight) / 2 + lineHeight - 6;

    for (let i = 0; i < lines.length; i++) {
      ctx.fillText(lines[i], boxX + boxWidth / 2, startY + i * lineHeight);
    }
  };

  try {
    const scaleFactor = 2;
    const canvasWidth = 378 * scaleFactor; // 756
    const canvasHeight = 567 * scaleFactor; // 1134

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    // === Outer Background ===
    const outerGradient = ctx.createLinearGradient(0, 0, 0, canvasHeight);
    outerGradient.addColorStop(0, "#FFD54F");
    outerGradient.addColorStop(1, "#FF9800");
    ctx.fillStyle = outerGradient;
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);

    // === Circles ===
    ctx.fillStyle = "rgba(255, 255, 255, 0.1)";
    ctx.beginPath();
    ctx.arc(100 * scaleFactor, 100 * scaleFactor, 80 * scaleFactor, 0, 2 * Math.PI);
    ctx.fill();
    ctx.beginPath();
    ctx.arc(280 * scaleFactor, 450 * scaleFactor, 60 * scaleFactor, 0, 2 * Math.PI);
    ctx.fill();

    // === Inner Card ===
    const cardX = 15 * scaleFactor;
    const cardY = 15 * scaleFactor;
    const cardWidth = canvasWidth - 30 * scaleFactor;
    const cardHeight = canvasHeight - 30 * scaleFactor;
    const radius = 20 * scaleFactor;

    const cardGradient = ctx.createLinearGradient(0, cardY, 0, cardY + cardHeight);
    cardGradient.addColorStop(0, "#fff8e1");
    cardGradient.addColorStop(1, "#ffe0b2");

    ctx.fillStyle = cardGradient;
    ctx.beginPath();
    ctx.moveTo(cardX + radius, cardY);
    ctx.lineTo(cardX + cardWidth - radius, cardY);
    ctx.quadraticCurveTo(cardX + cardWidth, cardY, cardX + cardWidth, cardY + radius);
    ctx.lineTo(cardX + cardWidth, cardY + cardHeight - radius);
    ctx.quadraticCurveTo(
      cardX + cardWidth,
      cardY + cardHeight,
      cardX + cardWidth - radius,
      cardY + cardHeight
    );
    ctx.lineTo(cardX + radius, cardY + cardHeight);
    ctx.quadraticCurveTo(cardX, cardY + cardHeight, cardX, cardY + cardHeight - radius);
    ctx.lineTo(cardX, cardY + radius);
    ctx.quadraticCurveTo(cardX, cardY, cardX + radius, cardY);
    ctx.closePath();
    ctx.fill();

    // === QR Code ===
    const qrCodeDataUrl = await QRCode.toDataURL(whatsappLink, {
      errorCorrectionLevel: "H",
      margin: 1,
      scale: 30,
    });

    const qrImage = new Image();
    const chaafoImage = new Image();
    const handiImage = new Image();

    qrImage.src = qrCodeDataUrl;
    chaafoImage.src = chaafo;
    handiImage.src = ChawlaLogo;

    return new Promise((resolve) => {
      qrImage.onload = () => {
        chaafoImage.onload = () => {
          handiImage.onload = () => {
            // === Logo (optional) ===
            const logoMaxWidth = 60 * scaleFactor;
            const logoY = 25 * scaleFactor;
            const logoAspectRatio = handiImage.width / handiImage.height;
            const logoWidth = logoMaxWidth;
            const logoHeight = logoWidth / logoAspectRatio;
            const logoX = (canvasWidth - logoWidth) / 2;

            // ctx.drawImage(handiImage, logoX, logoY, logoWidth, logoHeight);

            // === FIXED QR POSITION (unchanged) ===
            const qrSize = 240 * scaleFactor;
            const qrX = (canvasWidth - qrSize) / 2;
            const qrY = logoY + logoHeight + 50 * scaleFactor;
            ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize);

            // ✅ SAFE NAME AREA = between (below logo) and (above QR)
            const nameTop = logoY + logoHeight + 8 * scaleFactor;
            const nameBottom = qrY - 8 * scaleFactor; // keep gap above QR
            const nameBoxX = 40 * scaleFactor;
            const nameBoxY = nameTop;
            const nameBoxWidth = canvasWidth - 80 * scaleFactor;
            const nameBoxHeight = Math.max(40 * scaleFactor, nameBottom - nameTop);

            ctx.fillStyle = "#d84315";
            drawWrappedTextInBox(
              ctx,
              retaurentName,
              nameBoxX,
              nameBoxY,
              nameBoxWidth,
              nameBoxHeight,
              26 * scaleFactor, // base font (a bit bigger)
              3,               // ✅ allow 3 lines
              12 * scaleFactor
            );

            // === Order Text (unchanged) ===
            ctx.font = `600 ${20 * scaleFactor}px 'Segoe UI', sans-serif`;
            ctx.fillStyle = "#4e342e";
            ctx.textAlign = "center";
            ctx.fillText(
              "Scan to Order Your Food",
              canvasWidth / 2,
              qrY + qrSize + 35 * scaleFactor
            );

            // === Table Number Box (unchanged) ===
            const tableBoxY = qrY + qrSize + 60 * scaleFactor;
            ctx.fillStyle = "#ef6c00";
            ctx.fillRect(
              40 * scaleFactor,
              tableBoxY,
              canvasWidth - 80 * scaleFactor,
              45 * scaleFactor
            );

            ctx.font = `bold ${24 * scaleFactor}px 'Segoe UI', sans-serif`;
            ctx.fillStyle = "#fff";
            ctx.fillText(`TABLE ${tableId}`, canvasWidth / 2, tableBoxY + 30 * scaleFactor);

            // === Footer (unchanged) ===
            const footerY = tableBoxY + 80 * scaleFactor;
            const footerLogoWidth = 100 * scaleFactor;
            const footerLogoHeight = 30 * scaleFactor;

            ctx.font = `${14 * scaleFactor}px 'Poppins', sans-serif`;
            ctx.fillStyle = "#444";
            ctx.fillText("Powered by", canvasWidth / 2, footerY - 8 * scaleFactor);

            ctx.drawImage(
              chaafoImage,
              (canvasWidth - footerLogoWidth) / 2,
              footerY,
              footerLogoWidth,
              footerLogoHeight
            );

            resolve(canvas.toDataURL("image/png", 1.0));
          };
        };
      };
    });
  } catch (err) {
    console.error("Failed to generate QR Code", err);
    return null;
  }
};




  const handleDownloadQRCode = async (
    tableId,
    retaurentName,
    qrUrl,
    whatsappNumber,
    message
  ) => {
    const dataUrl = await generateQRCodeURL_10_15(
      tableId,
      retaurentName,
      qrUrl,
      whatsappNumber,
      message
    );

    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `table-${tableId}-qr-code-10x15.png`;
    link.click();
  };

  const handleDownloadQRCode_5_10 = async (
    tableId,
    retaurentName,
    qrUrl,
    whatsappNumber,
    message
  ) => {
    const dataUrl = await generateQRCodeURL_5_10(
      tableId,
      retaurentName,
      qrUrl,
      whatsappNumber,
      message
    );

    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `table-${tableId}-qr-code-5x10.png`;
    link.click();
  };

  const handleDownloadQRCode_only = async (
    tableId,
    retaurentName,
    qrUrl,
    whatsappNumber,
    message
  ) => {
    const dataUrl = await generateQRCodeURLOnly(
      tableId,
      retaurentName,
      qrUrl,
      whatsappNumber,
      message
    );

    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `table-${tableId}-qr-code-5x10.png`;
    link.click();
  };

  const handleDownloadAllQRCodesPDF_5_10 = async () => {
    setIsGeneratingPDF_5_10(true);
    const pdf = new jsPDF("portrait", "mm", "a4");

    // New sticker size (5cm x 10cm)
    const qrWidth = 100; // in mm (10cm)
    const qrHeight = 50; // in mm (5cm)

    const pageWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm

    const cols = 2; // 2 stickers per row
    const rows = 5; // 5 stickers per column

    const marginX = (pageWidth - cols * qrWidth) / (cols + 1); // space between and at sides
    const marginY = (pageHeight - rows * qrHeight) / (rows + 1);

    try {
      // Step 1: Generate all sticker images
      const qrImagePromises = tables.map((table) =>
        generateQRCodeURL_5_10(
          table.tableNo,
          table.retaurentName,
          table.qrUrl,
          table.whatsappNumber,
          table.message
        )
      );

      const qrImages = await Promise.all(qrImagePromises);
      const validImages = qrImages.filter(Boolean);

      // Step 2: Add each to PDF in grid
      let index = 0;
      for (let i = 0; i < validImages.length; i++) {
        const col = index % cols;
        const row = Math.floor(index / cols) % rows;

        const x = marginX + col * (qrWidth + marginX);
        const y = marginY + row * (qrHeight + marginY);

        pdf.addImage(validImages[i], "PNG", x, y, qrWidth, qrHeight);
        index++;

        // Step 3: New page after every 10 stickers (2 cols × 5 rows)
        if (index % (cols * rows) === 0 && i !== validImages.length - 1) {
          pdf.addPage();
        }
      }

      // Step 4: Save PDF
      pdf.save("Dining_Tables_QR_Stickers.pdf");
    } catch (err) {
      console.error("PDF generation failed:", err);
    } finally {
      setIsGeneratingPDF_5_10(false);
    }
  };

  const handleDownloadAllQRCodesPDF_10_15 = async () => {
    setIsGeneratingPDF_10_15(true);
    const pdf = new jsPDF("portrait", "mm", "a4");

    const qrWidth = 96;
    const qrHeight = 144;
    const pageWidth = 210;
    const pageHeight = 297;
    const cols = 2;
    const rows = 2;

    const marginX = (pageWidth - cols * qrWidth) / (cols + 1);
    const marginY = (pageHeight - rows * qrHeight) / (rows + 1);

    try {
      // 1. Generate all canvas images first
      const qrImagePromises = tables.map((table) =>
        generateQRCodeURL_10_15(
          table.tableNo,
          table.retaurentName,
          table.qrUrl,
          table.whatsappNumber,
          table.message
        )
      );

      const qrImages = await Promise.all(qrImagePromises);

      // 2. Filter out any failed ones
      const validImages = qrImages.filter(Boolean);

      // 3. Loop and add to PDF
      let index = 0;
      for (let i = 0; i < validImages.length; i++) {
        const col = index % cols;
        const row = Math.floor(index / cols) % rows;

        const x = marginX + col * (qrWidth + marginX);
        const y = marginY + row * (qrHeight + marginY);

        pdf.addImage(validImages[i], "PNG", x, y, qrWidth, qrHeight);

        index++;

        // Add new page after 4 images (2x2)
        if (index % (cols * rows) === 0 && i !== validImages.length - 1) {
          pdf.addPage();
        }
      }

      // 4. Save
      pdf.save("Dining_Tables_QR_Codes.pdf");
    } catch (err) {
      console.error("PDF generation failed:", err);
    } finally {
      setIsGeneratingPDF_10_15(false);
    }
  };

  const handleDownloadAllQRCodesAsZip_5_10 = async () => {
    setIsGeneratingZIP_5_10(true);
    const zip = new JSZip();

    try {
      // Step 1: Generate all QR images
      const qrImagePromises = tables.map((table) =>
        generateQRCodeURL_5_10(
          table.tableNo,
          table.retaurentName,
          table.qrUrl,
          table.whatsappNumber,
          table.message
        ).then((dataUrl) => ({
          dataUrl,
          fileName: `Table-${table.tableNo}.png`,
        }))
      );

      const qrImages = await Promise.all(qrImagePromises);
      const validImages = qrImages.filter((img) => img.dataUrl);

      // Step 2: Add each image to the zip folder
      for (const img of validImages) {
        const base64 = img.dataUrl.split(",")[1]; // remove data:image/png;base64,
        zip.file(img.fileName, base64, { base64: true });
      }

      // Step 3: Generate and trigger ZIP download
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "Dining_Table_QRCodes.zip");
    } catch (err) {
      console.error("ZIP generation failed:", err);
    } finally {
      setIsGeneratingZIP_5_10(false);
    }
  };

  const handleDownloadAllQRCodesAsZip_10_15 = async () => {
    setIsGeneratingZIP_5_10(true);
    const zip = new JSZip();

    try {
      // Step 1: Generate all QR images
      const qrImagePromises = tables.map((table) =>
        generateQRCodeURL_10_15(
          table.tableNo,
          table.retaurentName,
          table.qrUrl,
          table.whatsappNumber,
          table.message
        ).then((dataUrl) => ({
          dataUrl,
          fileName: `Table-${table.tableNo}.png`,
        }))
      );

      const qrImages = await Promise.all(qrImagePromises);
      const validImages = qrImages.filter((img) => img.dataUrl);

      // Step 2: Add each image to the zip folder
      for (const img of validImages) {
        const base64 = img.dataUrl.split(",")[1]; // remove data:image/png;base64,
        zip.file(img.fileName, base64, { base64: true });
      }

      // Step 3: Generate and trigger ZIP download
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "Dining_Table_QRCodes.zip");
    } catch (err) {
      console.error("ZIP generation failed:", err);
    } finally {
      setIsGeneratingZIP_10_15(false);
    }
  };

  const handleDownloadAllQRCodesAsZip_only_QR = async () => {
    setIsGeneratingZIP_Only(true);
    const zip = new JSZip();

    try {
      // Step 1: Generate all QR images
      const qrImagePromises = tables.map((table) =>
        generateQRCodeURLOnly(
          table.tableNo,
          table.retaurentName,
          table.qrUrl,
          table.whatsappNumber,
          table.message
        ).then((dataUrl) => ({
          dataUrl,
          fileName: `Table-${table.tableNo}.png`,
        }))
      );

      const qrImages = await Promise.all(qrImagePromises);
      const validImages = qrImages.filter((img) => img.dataUrl);

      // Step 2: Add each image to the zip folder
      for (const img of validImages) {
        const base64 = img.dataUrl.split(",")[1]; // remove data:image/png;base64,
        zip.file(img.fileName, base64, { base64: true });
      }

      // Step 3: Generate and trigger ZIP download
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "Dining_Table_QRCodes.zip");
    } catch (err) {
      console.error("ZIP generation failed:", err);
    } finally {
      setIsGeneratingZIP_Only(false);
    }
  };

  return (
    <div className="p-4 bg-light min-vh-100">
      <ToastContainer />
      <div className="px-4">
        
        {/* Page Title */}
        <div className="d-flex justify-content-between align-items-center">
          <div className="text-center mb-4 CreateCampaign">
            Download QR Codes
          </div>
        </div>
        {/* Bulk Download Section */}
        <div className="mb-5">
          <h5 className=" "> Bulk Download Options</h5>

          <div className="row g-4">
            {/* 10x15 Format */}
            <div className="col-4">
              <div className="card border-primary  shadow-sm w-100">
                <div className="card-body">
                  <h5 className="card-title text-primary"> QR 10×15 cm</h5>
                  <p className="card-text text-muted small">
                    Ideal for <strong>QR code standees</strong>. Includes
                    restaurant name, table number, QR code, and WhatsApp
                    prompt—perfect for displaying on counters, entrances, or
                    near tables with ample space.
                  </p>
                  <div className="d-flex flex-wrap gap-2">
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={handleDownloadAllQRCodesPDF_10_15}
                    >
                      {isGeneratingPDF_10_15 ? "Generating..." : "Generate PDF"}
                    </Button>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={handleDownloadAllQRCodesAsZip_10_15}
                    >
                      {isGeneratingZIP_10_15 ? "Generating..." : "Download ZIP"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            {/* 5x10 Format */}
            <div className="col-4">
              <div className="card border-success w-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-success"> QR 5×10 cm</h5>
                  <p className="card-text text-muted small">
                    Perfect for <strong>table stickers</strong> in compact
                    spaces. Shows the table number, QR code, and essential
                    info—ideal for pasting directly on table surfaces, trays, or
                    counters in smaller areas.
                  </p>
                  <div className="d-flex flex-wrap gap-2">
                    <Button
                      variant="success"
                      size="sm"
                      onClick={handleDownloadAllQRCodesPDF_5_10}
                    >
                      {isGeneratingPDF_5_10 ? "Generating..." : "Generate PDF"}
                    </Button>
                    <Button
                      variant="outline-success"
                      size="sm"
                      onClick={handleDownloadAllQRCodesAsZip_5_10}
                    >
                      {isGeneratingZIP_5_10 ? "Generating..." : "Download ZIP"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            {/* Only QR */}
            <div className="col-4">
              <div className="card border-dark w-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title"> Only QR Code</h5>
                  <p className="card-text text-muted small">
                    A <strong>minimalist</strong> version featuring only the QR
                    code. Designed for flexible use, such as embedding in menus,
                    posters, or packaging—great for custom layouts and branding
                    options.
                  </p>
                  <div>
                    <Button
                      variant="dark"
                      size="sm"
                      onClick={handleDownloadAllQRCodesAsZip_only_QR}
                    >
                      {isGeneratingZIP_Only ? "Generating..." : "Download ZIP"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Individual Table QR Section */}
        <div className="mt-5">
          <h5 className=" "> Table-wise QR Downloads</h5>
          <p className="text-muted small">
            Choose your preferred format for each table below.
          </p>

          <div className="row list-unstyled">
            {tables.map((table) => (
              <div key={table.id} className="col-4">
                <div className="card shadow-sm mb-3 w-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0">
                        Table <strong>#{table.tableNo}</strong>
                      </h6>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() =>
                          handleDownloadQRCode(
                            table.tableNo,
                            table.retaurentName,
                            table.qrUrl,
                            table.whatsappNumber,
                            table.message
                          )
                        }
                      >
                        QR 10×15
                      </Button>
                      <Button
                        variant="outline-success"
                        size="sm"
                        onClick={() =>
                          handleDownloadQRCode_5_10(
                            table.tableNo,
                            table.retaurentName,
                            table.qrUrl,
                            table.whatsappNumber,
                            table.message
                          )
                        }
                      >
                        QR 5×10
                      </Button>
                      <Button
                        variant="outline-dark"
                        size="sm"
                        onClick={() =>
                          handleDownloadQRCode_only(
                            table.tableNo,
                            table.retaurentName,
                            table.qrUrl,
                            table.whatsappNumber,
                            table.message
                          )
                        }
                      >
                        QR Only
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default QR_Code;
